/* eslint-disable */
import axios from 'axios'
import env from '../env/env'
import { getAccessToken } from '../utils/AuthUtil'
import { logErrorToServer } from '../utils/errorLogger'
import PostHogTracker from '../utils/PostHogTracker'

const client = axios.create({
  baseURL: env.API_URL,
})

client.interceptors.response.use(
  (response) => response,
  (error) => {
    // 🛑 Skip interceptor if this is the logging request itself
    if (error.config?.headers?.['x-no-error-log']) {
      return Promise.reject(error)
    }

    const log = {
      type: 'api-error',
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.message,
      stack: error.stack,
      payload: error.config?.data ? JSON.parse(error.config.data) : null,
      response: error.response?.data || null,
      time: new Date().toISOString(),
    }
    console.error('Axios API Error:', log)
    
    // Track API errors with PostHog
    const endpoint = error.config?.url || 'unknown'
    const statusCode = error.response?.status
    const errorMessage = error.response?.data?.message || error.message || 'Unknown error'
    const errorCode = error.response?.data?.errorCode || error.code || 'unknown'
    
    // Track different error types
    if (statusCode === 401 || statusCode === 403) {
      PostHogTracker.tokenExpiredError(endpoint)
    } else if (!error.response) {
      // Network error
      PostHogTracker.networkError(endpoint, errorMessage)
    } else {
      // General API error
      PostHogTracker.apiError(endpoint, errorCode, errorMessage, statusCode)
    }
    
    // logErrorToServer(log)
    return Promise.reject(error)
  },
)

const getConfig = async (headers, params) => {
  let config = {}
  if (!headers) {
    headers = {}
  }
  const jwtToken = await getAccessToken()
  if (jwtToken) {
    headers.Authorization = 'Bearer ' + jwtToken
  }
  config = {
    headers,
  }

  if (params) {
    config.params = params
  }
  return config
}

const post = async (url, data, headers, params) => {
  try {
    const config = await getConfig(headers, params)
    const response = await client.post(url, data, config)
    return response.data
  } catch (e) {
    if (
      (e.response.status === 401 || e.response.status === 403) &&
      !env.DO_NOT_VALIDATE_401.includes(url)
    ) {
      window.goToLogin()
    }
    return {
      isError: true,
      status: e.response.status,
      response: e.response.data,
    }
  }
}

const postRequest = async (url, data, headers, params) => {
  try {
    const config = await getConfig(headers, params)
    const response = await client.post(url, data, config)
    return response
  } catch (e) {
    if (
      (e.response.status === 401 || e.response.status === 403) &&
      !env.DO_NOT_VALIDATE_401.includes(url)
    ) {
      window.goToLogin()
    }
    return {
      isError: true,
      status: e,
      response: e.response.data,
    }
  }
}

const patch = async (url, data, headers, params) => {
  try {
    const config = await getConfig(headers, params)
    const response = await client.patch(url, data, config)
    return response.data
  } catch (e) {
    if (
      (e.response.status === 401 || e.response.status === 403) &&
      !env.DO_NOT_VALIDATE_401.includes(url)
    ) {
      window.goToLogin()
    }
    return {
      isError: true,
      status: e.response.status,
      response: e.response.data,
    }
  }
}

const get = async (url, headers, params) => {
  try {
    const config = await getConfig(headers, params)
    const response = await client.get(url, config)
    return response.data
  } catch (e) {
    if (
      (e.response.status === 401 || e.response.status === 403) &&
      !env.DO_NOT_VALIDATE_401.includes(url)
    ) {
      window.goToLogin()
    }
    return {
      isError: true,
      status: e.response.status,
      response: e.response.data,
    }
  }
}

const getMFData = async (headers, params) => {
  const url = '/mutualfundservice/api/mfData/allFunds'
  try {
    const config = await getConfig(headers, params)
    const response = await client.get(url, config)
    return response.data
  } catch (e) {
    if (
      (e.response.status === 401 || e.response.status === 403) &&
      !env.DO_NOT_VALIDATE_401.includes(url)
    ) {
      window.goToLogin()
    }
    return {
      isError: true,
      status: e.response.status,
      response: e.response.data,
    }
  }
}

const deleteReq = async (url, headers, params) => {
  try {
    const config = await getConfig(headers, params)
    const response = await client.delete(url, config)
    return response
  } catch (e) {
    if (
      (e.response.status === 401 || e.response.status === 403) &&
      !env.DO_NOT_VALIDATE_401.includes(url)
    ) {
      window.goToLogin()
    }
    return {
      isError: true,
      status: e.response.status,
      response: e.response.data,
    }
  }
}

export { post, get, patch, postRequest, deleteReq, getConfig, getMFData }
